// extracted by mini-css-extract-plugin
module.exports = {"container":"EventList_container__Qk4QP","header":"EventList_header__K5agD","dragger":"EventList_dragger__1_J3Z"};